module.exports = __webpack_public_path__ + "images/emoji/goat.8f7fed92c40005e83a1c.png";